import { Ref, ref } from 'vue';
import { isMobile, isMediumDevice, isDesktop, isTab } from '@/modules/platform/utils/platform';

interface Platform {
  isMobile: boolean;

  isMediumDevice: boolean;

  isTablet: boolean;

  isDesktop: boolean;
}

let initialized = false;
const platform: Ref<Platform> = ref({
  isMobile: false,
  isMediumDevice: false,
  isTablet: false,
  isDesktop: false,
});

const setDeviceType = () => {
  platform.value.isMobile = isMobile();
  platform.value.isMediumDevice = isMediumDevice();
  platform.value.isTablet = isTab();
  platform.value.isDesktop = isDesktop();
  console.debug('Setting device type: ', platform.value);
};

window.addEventListener('resize', setDeviceType);

export default () => {
  if (!initialized) {
    console.debug('Initializing usePlatform');
    setDeviceType();
    initialized = true;
  }
  return { platform };
};
